import { Lambda } from "../http-service";
import { tipoSistema } from "../../constants/Tipos/index";

export const cognitoRefresh = async (refresh_token, access_token, type = tipoSistema.ConsolaSoporte) => {
    const body = {
        refresh_token,
        type: type,
        access_token
    };

    return await Lambda({ resource: `auth/refresh`, method: "POST", isPublic: true, data: JSON.stringify(body) });
};

export const cognitoLogOut = async (access_token) => {
    const body = {
        access_token,
        type: tipoSistema.ConsolaSoporte
    };

    return await Lambda({ resource: `auth/logout`, method: "POST", isPublic: true, data: JSON.stringify(body) });
};